
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import nscee2776958b2b78957375d6991b75315en from './en.yaml'
            i18n.addResourceBundle('en', 'cee2776958b2b78957375d6991b75315', flattenObject(nscee2776958b2b78957375d6991b75315en), true, true);
        
        export default 'cee2776958b2b78957375d6991b75315';
    